import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output
} from '@angular/core';
import {IDsDropdownOption} from "../../../../../../shared/components/ds-dropdown/ds-dropdown-option";
import {ActivatedRoute, Router} from "@angular/router";
import {Utils} from "../../../../../../shared/utils/utils";
import {DbResponse} from "../../../../../../shared/interceptors/db-response";
import {NotifierComponent} from "../../../../../../shared/components/notifier/notifier.component";
import {Notification} from "../../../../../../shared/components/notifier/notification";
import {NotificationType} from "../../../../../../shared/components/notifier/notification-type";
import {Subscription} from "rxjs";
import {AiBuilderService} from "../../../../../../websites/website/ai-builder/service/ai-builder.service";
import {CookieService} from "ngx-cookie";
import {GoogleAnalyticsService} from "../../../../../../shared/services/google-analytics/google-analytics.service";
import {User} from "../../../../../../user/user";
import {filter, first} from "rxjs/operators";
import {AiAssistantService} from "../../../../../../ai-assistant/service/ai-assistant.service";
import {BuilderSectionsInteractionService} from "../../../../../../builder-v2/builder-sections-interaction.service";

@Component({
    selector: 'db-create-ai-assistant-company-type',
    templateUrl: './create-ai-assistant-company-type.component.html',
    styleUrls: ['./create-ai-assistant-company-type.component.scss'],
    standalone: false
})
export class CreateAiAssistantCompanyTypeComponent implements OnInit {
  @Input() selectedCompanyType = null;
  @Input() selectedBusinessCategory: string;
  @Input() isFirstStep: boolean = false;
  @Input() isOnboarding: boolean = false;
  @Input() hideBackButton: boolean = false;
  @Input() companyTypes;
  @Input() hasEcommerceService: boolean = true;
  @Input() nextIsTemplate: boolean = false;
  @Input() user: User;

  public fromStartAIPage: boolean = false;
  public companyTypesForView: any;
  public fromDomains: any;

  @Output() back = new EventEmitter<void>();
  @Output() companyTypeSelected = new EventEmitter<{ type: string; group: string }>();
  @Output() categoryType = new EventEmitter<string>();

  private encodedCompanyData: any = {};
  private _categoriesRequestSubscription: Subscription;
  private _filteredCategories = [];

  constructor(
    private readonly router: Router,
    private readonly _route: ActivatedRoute,
    private readonly _cookieService: CookieService,
    private readonly _builderService: AiBuilderService,
    private readonly _googleAnalyticsService: GoogleAnalyticsService,
    private _aiAssistantService: AiAssistantService,
    private _cdr: ChangeDetectorRef,
    private builderInteractionsService: BuilderSectionsInteractionService
  ) {
  }

  ngOnInit() {
    this.fromDomains = localStorage.getItem('dbOnboardingDomainName');
    if (!this.companyTypes) {
      this._aiAssistantService.getCategories(false, this.hasEcommerceService)
        .pipe(
          first(response => !!response),
        )
        .subscribe(response => {
          if (response.success) {
            this.companyTypes = response.data.map(({name, title, keywords, type}) => (
              {label: title, value: title, keywords, type}
            ));
            this._filteredCategories = this.companyTypes;
            this.companyTypesForView = this.companyTypes;
          }
        });
    } else {
      this.companyTypesForView = this.companyTypes;
    }

    this.fromStartAIPage = window.location.href.indexOf("start-ai-website-building") > -1;
    const queryParams: any = (<any>this._route.queryParams).value;
    const companyDataExist = !!queryParams.company_info;
    if (!!companyDataExist && !this.selectedCompanyType) {
      this.encodedCompanyData = Utils.b64DecodeUnicode(queryParams.company_info);
      if (!!this.encodedCompanyData.business_type) {
        this.selectCompanyType(this.encodedCompanyData.business_type);
      }
    }
  }


  public selectCompanyType(option: { value: IDsDropdownOption['value'], group: IDsDropdownOption['group'] }) {
    this.selectedCompanyType = option?.value as string;
    this.selectedBusinessCategory = option?.group as string;
  }

  public searchCategory($event) {
    if (this._categoriesRequestSubscription) {
      this._categoriesRequestSubscription.unsubscribe();
      this._categoriesRequestSubscription = null;
    }
    if ($event === '') {
      this._filteredCategories = this.companyTypes;
      return this.companyTypesForView = this.companyTypes;
    }
    this._categoriesRequestSubscription = this._builderService.searchCategories($event, false, this.hasEcommerceService)
      .pipe(filter((response: DbResponse): boolean => !!response),
        first())
      .subscribe((response: DbResponse): void => {
        if (response.success) {
          this._filteredCategories = response.data;
          const searchedResult = response.data.map((companyType) => (
            {
              label: companyType.title,
              highlightedLabel: companyType.title.replace(new RegExp($event, "gi"), (match) => `<span class="ds-highlighted">${match}</span>`),
              value: companyType.title,
              group: companyType.group
            }
          ));
          const combinedArray = [...searchedResult, ...this.companyTypesForView];

          this.companyTypesForView = combinedArray.filter((item, index, self) =>
              index === self.findIndex((t) => (
                t.value === item.value
              ))
          );
        } else {
          this.companyTypesForView = this.companyTypes;
          NotifierComponent.notify(new Notification(response.message, NotificationType.DANGER));
        }
        this._cdr.detectChanges();
      });
  }

  public onBackClick(): void {
    this.isOnboarding ? this.backToPreviousPage() : this.backToPreviousStep();
  }

  public backToPreviousStep(): void {
    this.back.emit();
  }

  private backToPreviousPage(): void {
    this.router.navigate(['/setup']);
  }

  public proceedToNextQuestion(): void {
/*    const categoryTypeArray = this._filteredCategories.filter(category =>
      category?.name?.toLowerCase() === this.selectedCompanyType?.toLowerCase() ||
      category?.title?.toLowerCase() === this.selectedCompanyType?.toLowerCase() ||
      category?.value?.toLowerCase() === this.selectedCompanyType?.toLowerCase());
    if (categoryTypeArray?.length) {
      this.categoryType.emit(categoryTypeArray[0].type);
    }*/
    this.categoryType.emit('basic');
    this.companyTypeSelected.emit({
      type: this.selectedCompanyType,
      group: this.selectedBusinessCategory,
    });
  }

}
